import IntersectionHydrator from '@netc/intersection-hydrator';
import { registrations } from '../registrations';
new IntersectionHydrator(registrations);
